// Configuración central de estados y complejidad de la solicitud corporativa.
// Mantiene coherencia visual entre /solicitud, /solicitud/solicitud-verificacion,
// la pantalla de gestión y el modal de detalle.
import type { CSSProperties } from 'react';

export type EstadoSolicitud = 'ESPERA' | 'REVISADO' | 'RECHAZADO';
export type ComplejidadSolicitud = 'BAJA' | 'MEDIA' | 'ALTA';

interface ChipConfig {
  label: string;
  color: string;
  bg: string;
}

export const ESTADO_SOLICITUD_CONFIG: Record<EstadoSolicitud, ChipConfig> = {
  ESPERA: { label: 'En espera', color: '#ed6c02', bg: '#fff3e0' },
  REVISADO: { label: 'Revisado', color: '#2e7d32', bg: '#e8f5e9' },
  RECHAZADO: { label: 'Rechazado', color: '#d32f2f', bg: '#ffebee' },
};

export const getEstadoConfig = (estado?: string): ChipConfig =>
  ESTADO_SOLICITUD_CONFIG[(estado ?? '').toUpperCase() as EstadoSolicitud] ??
  ESTADO_SOLICITUD_CONFIG.ESPERA;

export const COMPLEJIDAD_CONFIG: Record<ComplejidadSolicitud, ChipConfig> = {
  BAJA: { label: 'Baja', color: '#2e7d32', bg: '#e8f5e9' },
  MEDIA: { label: 'Media', color: '#ed6c02', bg: '#fff3e0' },
  ALTA: { label: 'Alta', color: '#d32f2f', bg: '#ffebee' },
};

export const getComplejidadConfig = (complejidad?: string): ChipConfig | null => {
  if (!complejidad) return null;
  return COMPLEJIDAD_CONFIG[complejidad.toUpperCase() as ComplejidadSolicitud] ?? null;
};

// Opciones para los selects/autocompletes de complejidad.
export const COMPLEJIDAD_OPCIONES = [
  { value: 'BAJA', label: 'Baja' },
  { value: 'MEDIA', label: 'Media' },
  { value: 'ALTA', label: 'Alta' },
];

// Pequeño componente visual reutilizable para pintar un estado/complejidad
// como "chip". Se define como helper de estilo para usar inline en celdas.
export const chipStyle = (cfg: ChipConfig): CSSProperties => ({
  color: cfg.color,
  backgroundColor: cfg.bg,
  padding: '4px 10px',
  borderRadius: '6px',
  fontSize: '0.75rem',
  fontWeight: 'bold',
  border: `1px solid ${cfg.color}`,
  display: 'inline-block',
  textAlign: 'center',
  minWidth: '90px',
});
